import api from "@/api";

export default {
  // API để lấy tất cả user có thể được gán việc
  getAll(params = {}) {
    // Giả sử bạn có endpoint /users để lấy tất cả user
    return api.get("/api/nguoi-dung/options", { params: params });
  },
  getAllPublic() {
    // Giả sử bạn có endpoint /users để lấy tất cả user
    return api.get("/api/workspaces/user");
  },
  getMe() {
    const username = localStorage.getItem("username");
    return api.get("/api/nguoi-dung?keyword=" + username + "&page=0&size=1");
  },

  getUsersChucVuCode(maChucVu) {
    return api.get(`/api/nguoi-dung/by-chuc-vu-code/${maChucVu}`);
  },
};
